/**
 * Sous-nœud (chemin développé) : une micro-étape guidée. Réutilise le QCM de
 * NoeudView sans pêche aux indices ni bouton d'aide (pas de décomposition d'un
 * sous-nœud), précédé d'un bandeau « on décompose ».
 */
import { Layers } from 'lucide-react';
import { NoeudView, type NoeudSubmitArgs } from './noeud-view';
import type { PlayerChoix, PlayerNoeud } from './types';

export function SubNoeudView({
  node,
  choix,
  step,
  total,
  submitting,
  onSubmit,
  paper = false,
}: {
  node: PlayerNoeud;
  choix: PlayerChoix[];
  step: number;
  total: number;
  submitting: boolean;
  onSubmit: (args: NoeudSubmitArgs) => void;
  paper?: boolean;
}) {
  return (
    <div className="space-y-3">
      <div className="bg-accent-50 text-accent-700 flex items-center gap-2 rounded-xl px-3 py-2 text-sm font-medium">
        <Layers className="h-4 w-4 shrink-0" />
        Chemin développé · étape {step} / {total}
      </div>
      <NoeudView
        node={node}
        choix={choix}
        indices={[]}
        allowHelp={false}
        submitting={submitting}
        onSubmit={onSubmit}
        paper={paper}
      />
    </div>
  );
}
